import React from "react";
export var ModifierGroup = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.maxAllowed, maxAllowed = _b === void 0 ? 0 : _b, _c = _a.selectedCount, selectedCount = _c === void 0 ? 0 : _c;
    var hasLimit = maxAllowed > 0;
    var hasReachedLimit = hasLimit && selectedCount >= maxAllowed;
    var formatCount = function (value) {
        if (Number.isInteger(value)) {
            return String(value);
        }
        return value.toFixed(1);
    };
    return (React.createElement("section", { className: "item-customization-section" },
        React.createElement("div", { className: "item-customization-section-header item-customization-section-header--stacked" },
            React.createElement("h3", { className: "item-customization-section-title" }, title),
            hasLimit ? (React.createElement("p", { className: ["item-customization-limit-message", hasReachedLimit ? "item-customization-limit-message--reached" : ""].filter(Boolean).join(" ") }, hasReachedLimit
                ? "Limit reached (".concat(formatCount(selectedCount), "/").concat(formatCount(maxAllowed), ").")
                : "Choose up to ".concat(formatCount(maxAllowed), " whole toppings (").concat(formatCount(selectedCount), "/").concat(formatCount(maxAllowed), ")."))) : null),
        children));
};
